import _ from 'underscore';
import Backbone from 'backbone';
import cookies from 'js-cookie';

function createKey(id, suffix) {
  return 'pk_lp_' + id + '_' + suffix;
}

export var PmlayerModel = Backbone.Model.extend({
  defaults: function () {
    return {
      isVisible: false,
      // 배너가 노출 되어야 하더라도, 한번에 하나씩 노출 해야한다.
      shouldBeShown: false,
      dailyLimit: 0,
      lifecycleLimit: 0,
      dailyShown: 0,
      lifecycleShown: 0,
      todayDismiss: 0,
      startedAt: 0,
      endAt: 0,
      todayEndAt: 0
    };
  },

  initialize: function () {
    this.fetch();
  },

  parse: function (value) {
    var shouldBeShown = false;

    // 먼저 노출 조건부터 체크
    if (value.todayDismiss < 1) {
      shouldBeShown = true;
    }
    if (value.lifecycleLimit === 0 || value.lifecycleShown <= value.lifecycleLimit) {
      shouldBeShown = true;
    }
    if (value.dailyLimit === 0 || value.dailyShown <= value.dailyLimit) {
      shouldBeShown = true;
    }

    // 미노출 조건
    if (value.dailyLimit > 0 && value.dailyShown > value.dailyLimit) {
      shouldBeShown = false; // 하루 노출 제한
    }
    if (value.lifecycleLimit > 0 && value.lifecycleShown > value.lifecycleLimit) {
      shouldBeShown = false; // 전체 기간 노출 제한
    }
    if (value.todayDismiss > 0) {
      shouldBeShown = false; // 오늘 하루 보지 않음 체크
    }

    return _.extend(value, {
      shouldBeShown: shouldBeShown
    });
  },

  setVisible: function (status) {
    this.set('isVisible', status);
    var ds = this.get('dailyShown');
    var ls = this.get('lifecycleShown');

    // 하루 / 전체 기간에 노출한 수를 기록
    this.set('dailyShown', ds + 1);
    this.set('lifecycleShown', ls + 1);
    this.save();
  },

  setClose: function () {
    this.set('isVisible', false);
    this.save();
  },

  setDismiss: function () {
    var td = this.get('todayDismiss');
    this.set('todayDismiss', td + 1);
    this.setClose();
  },

  sync: function (method, model, options) {
    var dailyShown;
    var lifecycleShown;
    var todayDismiss;

    if (method === 'read') {
      // model.fetch
      if (!model.id) {
        return;
      }
      dailyShown = parseInt(cookies.get(createKey(model.id, 'ds')), 10) || 0;
      lifecycleShown = parseInt(cookies.get(createKey(model.id, 'ls')), 10) || 0;
      todayDismiss = parseInt(cookies.get(createKey(model.id, 'td')), 10) || 0;

      options.success(
        _.extend(model.toJSON(), {
          dailyShown: dailyShown,
          lifecycleShown: lifecycleShown,
          todayDismiss: todayDismiss
        })
      );
    } else if (method === 'create' || method === 'update') {
      // model.save
      dailyShown = model.get('dailyShown');
      lifecycleShown = model.get('lifecycleShown');
      todayDismiss = model.get('todayDismiss');

      cookies.set(createKey(model.id, 'ds'), dailyShown, {
        expires: new Date(model.get('todayEndAt')) // 오늘 자정까지
      });
      cookies.set(createKey(model.id, 'ls'), lifecycleShown, {
        expires: new Date(model.get('endAt')) // 배너 종료 시까지
      });
      cookies.set(createKey(model.id, 'td'), todayDismiss, {
        expires: new Date(model.get('todayEndAt')) // 오늘 자정까지
      });

      // 이미 노출 횟수를 변경했기 때문에 여기서는 그냥 저장 콜백 실행
      options.success(model.toJSON());
    }
  }
});

export function getValueFromPmlayerDOM(el) {
  var $el = $(el);
  var id = $el.data('pmlayerId');
  var dailyLimit = $el.data('pmlayerDailyLimit');
  var lifecycleLimit = $el.data('pmlayerLifecycleLimit');
  var startedAt = $el.data('pmlayerStartedAt');
  var endAt = $el.data('pmlayerEndAt');
  var todayEndAt = $el.data('pmlayerTodayEndAt');

  var values = {
    id: id,
    dailyLimit: dailyLimit,
    lifecycleLimit: lifecycleLimit,
    startedAt: startedAt,
    endAt: endAt,
    todayEndAt: todayEndAt
  };
  return values;
}
